import Modal from "../modal/Modal";
import { useTranslation } from "react-i18next";
import { Button, Checkbox } from "@mantine/core";
import React, { useState } from "react";
type TModalProps = {
  setModalVisible: (value: boolean) => void;
  modalVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  orderedQuantity: Number;
  uploadedQuantity: Number;
};

const QuantityModal: React.FC<TModalProps> = ({
  setModalVisible,
  modalVisible,
  onConfirm,
  onCancel,
  orderedQuantity,
  uploadedQuantity,
}) => {
  const { t } = useTranslation();
  const [approved, setApproved] = useState<boolean>(false);
  return (
    <Modal
      style="confirm-modal-container"
      stylecontent="confirm-modal-content"
      compact
      center
      visible={modalVisible}
      onClose={() => setModalVisible(false)}
    >
      <div className="text-center mb-20">
        <h2 className="f-w-700">{t("IncorrectQuantity")}</h2>
      </div>
      {uploadedQuantity == 0 ? (
        <div>
          <div className="text-center">
            <p>{t("noPrintData")}</p>
            <br />
          </div>
          <div className="row gap-30 row-column-phone-responsive">
            <Button
              mt={10}
              size="lg"
              style={{
                color: "white",
                maxWidth: "250px",
                width: "100%",
                margin: "0 auto",
              }}
              color={"blue"}
              fullWidth
              onClick={onCancel}
            >
              {t("uploadPrintdata")}
            </Button>
          </div>
        </div>
      ) : orderedQuantity < uploadedQuantity && uploadedQuantity !== 0 ? (
        <div>
          <div className="text-center">
            <p>{t("QuantityMessageHigh")}</p>
            <br />
            <p>
              <b>
                {t("orderedQuantityMessage")}
                {orderedQuantity.toString()}
              </b>
              <br />
            </p>
            <p>
              <b>
                {t("uploadedQuantityMessage")}
                <a style={{ color: "red" }}>{uploadedQuantity.toString()}</a>
              </b>
            </p>
          </div>
          <div
            style={{ padding: "50px" }}
            className="row gap-30 row-column-phone-responsive"
          >
            <Button
              mt={10}
              size="lg"
              style={{
                color: "black",
                maxWidth: "250px",
                width: "100%",
                margin: "0 auto",
              }}
              color={"yellow"}
              fullWidth
              onClick={onCancel}
            >
              {t("adjustPrintdata")}
            </Button>
          </div>
        </div>
      ) : (
        <div>
          <div className="text-center">
            <p>{t("QuantityMessageLow")}</p>
            <br />
            <p>{t("QuantityMessageNote")}</p>
            <br />
            <b>
              {t("orderedQuantityMessage")}
              {orderedQuantity.toString()}
            </b>
            <br />
            <b>
              {t("uploadedQuantityMessage")}
              <a style={{ color: "#E6DC00" }}>{uploadedQuantity.toString()}</a>
            </b>
          </div>
          <Checkbox
            radius={5}
            label={t("printAssignment")}
            className="checkbox-border "
            checked={approved}
            onChange={(e: any) => setApproved(e.target.checked)}
          />
          <div className="row gap-30 row-column-phone-responsive">
            <Button
              mt={10}
              size="lg"
              color={"blue"}
              disabled={!approved}
              fullWidth
              onClick={onConfirm}
            >
              {t("sendToProduction")}
            </Button>
            <Button
              className={"modal-outlined-button"}
              color={"blue"}
              variant={"outline"}
              mt={10}
              size="lg"
              fullWidth
              onClick={onCancel}
            >
              {t("addPrintAssignment")}
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default QuantityModal;
